import autobind from 'class-autobind';

class LocalStorageManager {
  
  constructor({ namespace, userId }) {
    if (!namespace || !userId) {
      throw new Error('LocalStorageManager must be called with a "namespace" and "userId"');
    }

    this.keyBase = `com.zoomforth.${namespace}.${userId}.`;
    autobind(this);
  }

  get(key, defaultValue) {
    const value = window.localStorage[this.keyBase + key];
    if (value) {
      return JSON.parse(value);
    }
    return defaultValue;
  }

  set(key, value) {
    window.localStorage.setItem(this.keyBase + key, JSON.stringify(value));
  }

  remove(key) {
    window.localStorage.removeItem(this.keyBase + key);
  }

}

export default LocalStorageManager;
